import type { ReactNode } from "react";
import IconCheck from "ui/icons/IconCheck";
import styles from "./Checklist.module.scss";

interface ChecklistProps {
  items: string[];
  icon?: ReactNode;
}

export default function Checklist({ items, icon }: ChecklistProps) {
  const checklistIcon = icon ?? <IconCheck size={12} color="stone" />;

  return (
    <div className={styles.wrapper}>
      <div className="checklist">
        {items.map((item, index) => (
          <div key={index} className="checklist-item">
            <div>{checklistIcon}</div>
            <div>{item}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
